export default __webpack_public_path__ + "static/ELE-Barcelona-folleto-d17f92d14b57e7db7f42b2e6485cf7dd.pdf";